import type { Canvas } from "../../Canvas.ts";
import type { CardRarity } from "../../../Domain/CardAppearance.ts";
import { type Drawable, MAX_SIZE, type Position, type Size, ZERO_SIZE } from "../../Drawable.ts";
import { drawBorderAsset } from "./MetalBeveledBorder.ts";

export type CardFrameRarity = CardRarity;

const assetPath = (name: string): string => `/images/assets/card-frame/rarity/${name}.png`;

const badgeAssets = {
	corner: assetPath("corner-panel"),
	edgeHorizontal: assetPath("edge-panel-horizontal"),
	edgeVertical: assetPath("edge-panel-vertical"),
};

export const RARITY_FRAME_ASSETS = {
	common: {
		artFrame: assetPath("common-art-frame"),
		panelHeading: assetPath("common-panel-heading"),
		panelBodyA: assetPath("common-panel-body-a"),
		panelBodyB: assetPath("common-panel-body-b"),
		panelFooter: assetPath("common-panel-footer"),
		...badgeAssets,
	},
	rare: {
		artFrame: assetPath("rare-art-frame"),
		panelHeading: assetPath("rare-panel-heading"),
		panelBodyA: assetPath("rare-panel-body-a"),
		panelBodyB: assetPath("rare-panel-body-b"),
		panelFooter: assetPath("rare-panel-footer"),
		...badgeAssets,
	},
	legendary: {
		artFrame: assetPath("legendary-art-frame"),
		panelHeading: assetPath("legendary-panel-heading"),
		panelBodyA: assetPath("legendary-panel-body-a"),
		panelBodyB: assetPath("legendary-panel-body-b"),
		panelFooter: assetPath("legendary-panel-footer"),
		...badgeAssets,
	},
} as const;

export const ALL_RARITY_FRAME_ASSETS = [
	...new Set(Object.values(RARITY_FRAME_ASSETS).flatMap((assets) => Object.values(assets))),
];

export class RarityCardFrame implements Drawable {
	constructor(private readonly rarity: CardFrameRarity) {}

	public draw(document: Canvas, position: Position, size: Readonly<Size>): void {
		const assets = RARITY_FRAME_ASSETS[this.rarity];
		const segments = [
			[assets.artFrame, 0, 760],
			[assets.panelHeading, 760, 130],
			[assets.panelBodyA, 890, 60],
			[assets.panelBodyA, 950, 60],
			[assets.panelBodyB, 1010, 60],
			[assets.panelFooter, 1070, 184],
		] as const;
		for (const [asset, top, height] of segments) {
			drawBorderAsset(
				document,
				asset,
				position.x,
				position.y + (size.height * top) / 1254,
				size.width,
				(size.height * height) / 1254,
			);
		}
	}

	public minSize(): Size {
		return ZERO_SIZE;
	}

	public maxSize(): Size {
		return MAX_SIZE;
	}

	public widthToHeightRatio(): number {
		return 1;
	}
}
